<aside class="ui-sidebar" [class.ui-sidebar--collapsed]="collapsed()">
  <header class="ui-sidebar__brand">
    <div class="ui-sidebar__brand-main">
      <button
        type="button"
        class="brand-monogram"
        [class.brand-monogram--clickable]="collapsed()"
        [attr.aria-label]="collapsed() ? ('sidebar.actions.expand' | translate) : ('sidebar.actions.logo' | translate)"
        (click)="onLogoClick()"
      >
        P
      </button>
      <div class="brand-text">
        <strong>PALLADIUM</strong>
        <span>AFRICA</span>
      </div>
    </div>
    @if (!collapsed()) {
      <button
        type="button"
        class="ui-sidebar__collapse-btn"
        (click)="toggleCollapsed()"
        [attr.aria-label]="'sidebar.actions.collapse' | translate"
        aria-controls="sidebar-nav"
        [attr.aria-expanded]="true"
      >
        <span class="material-symbols-rounded" aria-hidden="true">keyboard_arrow_left</span>
      </button>
    }
  </header>

  <nav class="ui-sidebar__nav" id="sidebar-nav">
    @for (item of items(); track trackNavItem(item)) {
      @if (item.children?.length) {
        <div class="ui-sidebar__group">
          <button
            type="button"
            class="ui-sidebar__item ui-sidebar__item--group-parent"
            [attr.title]="collapsed() ? (item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate)) : null"
            [attr.aria-expanded]="isGroupExpanded(item.path)"
            (click)="onGroupParentClick(item.path)"
          >
            <span class="ui-sidebar__icon material-symbols-rounded" aria-hidden="true">{{ resolveItemIcon(item) }}</span>
            <span class="ui-sidebar__label">{{ item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate) }}</span>
          </button>
          <button
            type="button"
            class="ui-sidebar__group-toggle"
            [attr.aria-label]="('sidebar.actions.toggle' | translate) + ' ' + (item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate))"
            (click)="toggleGroup(item.path)"
            [attr.aria-expanded]="isGroupExpanded(item.path)"
          >
            <span class="material-symbols-rounded" [class.ui-sidebar__arrow--open]="isGroupExpanded(item.path)">
              keyboard_arrow_down
            </span>
          </button>
        </div>
        @if (isGroupExpanded(item.path) && !collapsed()) {
          @for (child of item.children; track trackNavItem(child)) {
            <a
              class="ui-sidebar__item ui-sidebar__item--child"
              routerLinkActive="is-active"
              [routerLink]="child.path"
              [queryParams]="child.queryParams"
              [routerLinkActiveOptions]="childActiveMatchOptions"
            >
              <span class="ui-sidebar__icon material-symbols-rounded" aria-hidden="true">{{ resolveItemIcon(child) }}</span>
              <span class="ui-sidebar__label">{{ child.labelKey ? (child.labelKey | translate) : (child.label | uiLabelTranslate) }}</span>
            </a>
          }
        }
      } @else {
        <a
          class="ui-sidebar__item"
          routerLinkActive="is-active"
          [routerLink]="item.path"
          [queryParams]="item.queryParams"
          [routerLinkActiveOptions]="topLevelActiveMatchOptions"
          [attr.title]="collapsed() ? (item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate)) : null"
        >
          <span class="ui-sidebar__icon material-symbols-rounded" aria-hidden="true">{{ resolveItemIcon(item) }}</span>
          <span class="ui-sidebar__label">{{ item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate) }}</span>
        </a>
      }
    }
  </nav>

  <footer class="ui-sidebar__footer">
    <div class="user-avatar">{{ user().initials }}</div>
    <div class="user-meta">
      <strong>{{ user().name }}</strong>
      <span>{{ user().role | translate }}</span>
    </div>
  </footer>
</aside>
